import React from "react";
import PropTypes from "prop-types";
import { Grid, Box, Typography } from "@mui/material";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import Mapa from "./components/Map";
import PerformaceDistribuidor from "./components/PerformaceDistribuidor";
import PerformanceEstado from "./components/PerformanceEstado";
import PerformanceGrupo from "./components/PerformanceGrupo";
import { Footer } from "../../components/Footer/Footer";
import { OverviewCardSkeleton } from "../../components/Cards";
import { useOverviewData } from "../../hooks";

function BaseCovarageDesktop({ app }) {
  const { isLoading } = useOverviewData(app);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <Grid
            container
            flexDirection="column"
            justifyContent="flex-start"
            rowGap={2}
          >
            {isLoading ? (
              <Grid container spacing={2} sx={{ marginTop: "37px" }}>
                {/* First row - 2 columns */}
                <Grid item xs={12} md={4}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
                <Grid item xs={12} md={8}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>

                {/* Second row - 4 equal columns */}
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
              </Grid>
            ) : (
              <Grid item spacing={2} sx={{ marginTop: "37px" }}>
                <Box className="container-card-title">
                    <Typography variant="h1" className="title">
                      Performance por Região
                    </Typography>
                  </Box>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4} className="container-tables-tops">
                    <Mapa app={app} />
                  </Grid>
                  <Grid item xs={12} md={8} className="container-tables-tops">
                    <PerformaceDistribuidor app={app} />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid
                    item
                    spacing={2}
                    xs={12}
                    md={6}
                    className="container-tables-tops"
                  >
                    <PerformanceEstado app={app} />
                  </Grid>
                  <Grid
                    item
                    spacing={2}
                    xs={12}
                    md={6}
                    className="container-tables-tops"
                  >
                    <PerformanceGrupo app={app} />
                  </Grid>
                </Grid>

                <Box item spacing={2} sx={{ marginTop: "31px" }}>
                  <Footer app={app} customClass={"footer-regional"} />
                </Box>
              </Grid>
            )}
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

BaseCovarageDesktop.propTypes = {
  app: PropTypes.object,
};

export default BaseCovarageDesktop;
